import { call, put, takeLatest, fork, all } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParams } from '../utils/commonUtils';
import i18n from '../constants/initLng';
import Banner from '../models/Banner';
import { PATHS } from '../constants/Define';
import * as BannerActions from '../actions/bannerAction';
import { BannerService } from './../services';
import history from '../helpers/history';


function* getListBanner() {
    yield takeLatest(Types.BANNER_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {});
        const result = yield call(BannerService.getBanners, params);
        yield put(BannerActions.dataBannerSuccess(result));
    }, errorHandleBanner(Types.BANNER_FAIL)))
}

function* getBannerDetail() {
    yield takeLatest(Types.BANNER_GET_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(BannerService.getBannerDetail, action.params.id);
        yield put(BannerActions.getUpdateBannerSuccess(result));
    }, errorHandleBanner(Types.BANNER_FAIL)))
}

function* createBanner() {
    yield takeLatest(Types.BANNER_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const banner = (action.params.data);
        yield call(BannerService.createBanner, banner);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), banner.name);
        yield put({ type: Types.BANNER_LIST_ACTION, filters: action.params.filters });
        history.push(PATHS.BANNER.LIST.path);
        history.go();
    }, errorHandleBanner(Types.BANNER_FAIL)))
}

function* updateBanner() {
    yield takeLatest(Types.BANNER_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const banner = (action.params.data);
        yield call(BannerService.updateBanner, banner);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), banner.name);
        yield put({ type: Types.BANNER_LIST_ACTION, filters: action.params.PageIndex })
    }, errorHandleBanner(Types.BANNER_FAIL)))
}

function* deleteBanner() {
    yield takeLatest(Types.BANNER_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(BannerService.deleteBanner, action.params.id);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.203'));
        yield put({ type: Types.BANNER_LIST_ACTION, filters: action.params.PageIndex })
    }, errorHandleBanner(Types.BANNER_FAIL)))
}

// TRANSLATE
function* createBannerTranslate() {
    yield takeLatest(Types.BANNER_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(BannerService.createBannerTranslate, action.banner);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.banner.translate.languageName);
        yield put({ type: Types.BANNER_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.BANNER_GET_UPDATE_ACTION, params: { id: action.banner.id } });
    }, errorHandleBanner(Types.BANNER_FAIL)))
}

function* updateBannerTranslate() {
    yield takeLatest(Types.BANNER_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(BannerService.updateBannerTranslate, action.banner);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.banner.translate.languageName);
        yield put({ type: Types.BANNER_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.BANNER_GET_UPDATE_ACTION, params: { id: action.banner.id } });
    }, errorHandleBanner(Types.BANNER_FAIL)))
}

function* deleteBannerTranslate() {
    yield takeLatest(Types.BANNER_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(BannerService.deleteBannerTranslate, action.banner.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.banner.translate.languageName);
        yield put({ type: Types.BANNER_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.BANNER_GET_UPDATE_ACTION, params: { id: action.refreshParams.id } });
    }, errorHandleBanner(Types.BANNER_FAIL)))
}



function errorHandleBanner(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'banner');
}

export function* bannerSaga() {
    yield all([
        fork(getListBanner),
        fork(createBanner),
        fork(deleteBanner),
        fork(getBannerDetail),
        fork(updateBanner),
        fork(createBannerTranslate),
        fork(updateBannerTranslate),
        fork(deleteBannerTranslate),
    ])
}
